/* global refreshAngularData */
// window.moment = require('moment');
// window.qq = require('fine-uploader/jquery.fine-uploader/jquery.fine-uploader');

export const MainApp = {
	Instances: {},
	Views: {},
	Date: {
		DateTimeFormat: '{0:yyyy-MM-dd HH:mm}',
		DateFormat: '{0:yyyy-MM-dd}',
		TimeFormat: '{HH:mm}',
	},
}

MainApp.Main = {
	init() {
		// register lowercase of view modules, to work with lowercase controller/action
		Object.keys(MainApp.Views).forEach((key) => {
			MainApp.Views[key.toLowerCase()] = MainApp.Views[key]
		})
	},

	loadForView(viewName) {
		// / <summary>Load Js for a view based on convention controller + action</summary>
		if (!viewName) return
		const ViewModule = MainApp.Views[viewName]
		if (ViewModule && ViewModule.prototype && ViewModule.prototype.init) {
			const viewInstance = new ViewModule()
			MainApp.Instances[viewName] = viewInstance
			viewInstance.init()
		}
	},

	initMultiSelect() {
		$('.js-multiselect').each((_, elm) => {
			$(elm).multiselect({
				templates: {
					li: '<li><a href="javascript:void(0);" class="dropdown-item"><label></label></a></li>',
				},
				enableHTML: true,
				optionLabel(element) {
					const value = $(element).val()
					if ($(element).parent().attr('name') === 'OrderStatusId') {
						if (value === 20) {
							return `<span class="badge bg-info">${$(element).html()}</span>`
						}
						if (value === 30) {
							return `<span class="badge bg-success">${$(element).html()}</span>`
						}
						if (value === 40) {
							return `<span class="badge bg-danger">${$(element).html()}</span>`
						}
						return `<span class="badge bg-light">${$(element).html()}</span>`
					}
					if ($(element).parent().attr('name') === 'PaymentStatusId') {
						if (value === 20) {
							return `<span class="badge bg-info">${$(element).html()}</span>`
						}
						if (value === 35) {
							return `<span class="badge bg-warning">${$(element).html()}</span>`
						}
						if (value === 30) {
							return `<span class="badge bg-success">${$(element).html()}</span>`
						}
						if (value === 40) {
							return `<span class="badge bg-success">${$(element).html()}</span>`
						}
						if (value === 50) {
							return `<span class="badge bg-danger">${$(element).html()}</span>`
						}
						return `<span class="badge bg-light">${$(element).html()}</span>`
					}
					if ($(element).parent().attr('name') === 'ShippingStatusId') {
						if (value === 10) {
							return `<span class="badge bg-success">${$(element).html()}</span>`
						}
						if (value === 20) {
							return `<span class="badge bg-light">${$(element).html()}</span>`
						}
						if (value === 25 || value === 30) {
							return `<span class="badge bg-info">${$(element).html()}</span>`
						}
						if (value === 40) {
							return `<span class="badge bg-success">${$(element).html()}</span>`
						}
						return `<span class="badge bg-light">${$(element).html()}</span>`
					}
					if ($(element).parent().attr('name') === 'FulfillmentStatusId') {
						if (value === 0) {
							return `<span class="badge bg-danger">${$(element).html()}</span>`
						}
						if (value === 1) {
							return `<span class="badge bg-warning">${$(element).html()}</span>`
						}
						if (value === 2) {
							return `<span class="badge bg-success">${$(element).html()}</span>`
						}
						return `<span class="badge bg-light">${$(element).html()}</span>`
					}

					if ($(element).parent().attr('name') === 'ProductLabelsId') {
						return `<span class="badge bg-primary">${$(element).html()}</span>`
					}

					return $(element).html()
				},
				onChange(element, _checked) {
					if ($(element).parent().data('controller') && $(element).parent().attr('name') !== 'ProductLabelsId') {
						const controllername = $(element).parent().data('controller')

						refreshAngularData(controllername)

						$('#js-filterCounter').show()
						$('#js-filterCounter').html($('.multiselect-container').find("input[type='checkbox']:checked").length)
					}
				},
			})
		})
	},
	initMultiBox() {
		$('.multibox').each((_, elm) => {
			if ($(elm).data('url') && $(elm).data('saveurl')) {
				$.ajax({
					url: $(elm).data('url'),
				}).done((data) => {
					$(elm).find('option').remove().end()
					$.each(data, (_, item) => {
						$(elm).append(
							$('<option>', {
								value: item.Value,
								text: item.Text,
								selected: item.Selected,
							}),
						)
					})
					$(elm).bootstrapDualListbox()
					$(elm).on('change', () => {
						const parts = $(elm).data('saveurl').split('?')
						let postData = `${$(elm).attr('id')}=${$(elm).val()}`
						if (parts.length > 1) {
							postData = `${postData}&${parts[1]}`
						}
						$.ajax({
							beforeSend(xhr) {
								xhr.setRequestHeader('__RequestVerificationToken', $('input[name=__RequestVerificationToken]').val())
							},
							type: 'POST',
							url: parts[0],
							data: postData,
						}).done((_data) => {
							if ($(elm).data('controller')) {
								const controllerName = $(elm).data('controller')
								refreshAngularData(controllerName)
							}
						})
					})
				})
			}
		})
	},
}

$(() => {
	MainApp.Main.init()
	MainApp.Main.initMultiSelect()
	MainApp.Main.initMultiBox()
})
